module.exports = __webpack_public_path__ + "img/welcome_18.ea979b8e.jpg";